import React from 'react';
import { AlertTriangleIcon, TruckIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
const KpiCards: React.FC = () => {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-129">
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-130">
        <div className="flex items-center" data-id="element-131">
          <div className="p-2 rounded-full bg-red-100 mr-3" data-id="element-132">
            <AlertTriangleIcon size={24} className="text-[#e53935]" data-id="element-133" />
          </div>
          <div data-id="element-134">
            <p className="text-sm text-gray-500" data-id="element-135">Risk Score</p>
            <div className="flex items-baseline" data-id="element-136">
              <h3 className="text-xl font-bold text-[#333333]" data-id="element-137">28</h3>
              <span className="ml-2 text-xs text-red-500" data-id="element-138">
                +5 from last month
              </span>
            </div>
          </div>
        </div>
        <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-139">
          <div className="h-full bg-[#e53935] rounded-full" style={{
          width: '28%'
        }} data-id="element-140"></div>
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-141">
        <div className="flex items-center" data-id="element-142">
          <div className="p-2 rounded-full bg-yellow-100 mr-3" data-id="element-143">
            <TruckIcon size={24} className="text-[#fbc02d]" data-id="element-144" />
          </div>
          <div data-id="element-145">
            <p className="text-sm text-gray-500" data-id="element-146">On-Time Delivery</p>
            <div className="flex items-baseline" data-id="element-147">
              <h3 className="text-xl font-bold text-[#333333]" data-id="element-148">84%</h3>
              <span className="ml-2 text-xs text-yellow-500" data-id="element-149">
                -3% from target
              </span>
            </div>
          </div>
        </div>
        <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-150">
          <div className="h-full bg-[#fbc02d] rounded-full" style={{
          width: '84%'
        }} data-id="element-151"></div>
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-152">
        <div className="flex items-center" data-id="element-153">
          <div className="p-2 rounded-full bg-green-100 mr-3" data-id="element-154">
            <ClockIcon size={24} className="text-[#4caf50]" data-id="element-155" />
          </div>
          <div data-id="element-156">
            <p className="text-sm text-gray-500" data-id="element-157">Lead Time</p>
            <div className="flex items-baseline" data-id="element-158">
              <h3 className="text-xl font-bold text-[#333333]" data-id="element-159">12.5 days</h3>
              <span className="ml-2 text-xs text-green-500" data-id="element-160">
                -0.5 days improvement
              </span>
            </div>
          </div>
        </div>
        <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-161">
          <div className="h-full bg-[#4caf50] rounded-full" style={{
          width: '65%'
        }} data-id="element-162"></div>
        </div>
      </div>
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" data-id="element-163">
        <div className="flex items-center" data-id="element-164">
          <div className="p-2 rounded-full bg-blue-100 mr-3" data-id="element-165">
            <DollarSignIcon size={24} className="text-[#005a9e]" data-id="element-166" />
          </div>
          <div data-id="element-167">
            <p className="text-sm text-gray-500" data-id="element-168">Total Spend</p>
            <div className="flex items-baseline" data-id="element-169">
              <h3 className="text-xl font-bold text-[#333333]" data-id="element-170">$4.2M</h3>
              <span className="ml-2 text-xs text-blue-500" data-id="element-171">+2.1% YTD</span>
            </div>
          </div>
        </div>
        <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-172">
          <div className="h-full bg-[#005a9e] rounded-full" style={{
          width: '42%'
        }} data-id="element-173"></div>
        </div>
      </div>
    </div>;
};
export default KpiCards;